import { CardContent, Grid, Skeleton, Box, Toolbar, CardActions, Button } from '@mui/material'
import Header from 'components/Header'
import { useTranslation } from 'react-i18next'

export default function AcademicYearSkeleton() {
  const { t } = useTranslation()
  return (
    <Box component="form" noValidate>
      <Toolbar />
      <Header title={t('Add Marking Periods')} small close />
      <CardContent>
        <Grid item xs={12}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Skeleton height={60} />
            </Grid>
            <Grid item xs={12}>
              <Skeleton height={60} />
            </Grid>
            <Grid item xs={12}>
              <Skeleton height={60} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Skeleton height={50} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Skeleton height={50} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Skeleton height={50} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Skeleton height={50} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Skeleton height={50} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Skeleton height={50} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Skeleton height={50} />
            </Grid>
            <Grid item sm={6} xs={12}>
              <Skeleton height={50} />
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end', mr: 1 }}>
        <Button variant="outlined">
          <Skeleton height={20} width={50} />
        </Button>
        <Button type="submit" variant="contained">
          <Skeleton height={20} width={50} />
        </Button>
      </CardActions>
    </Box>
  )
}
